import {
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnInit,
  AfterViewInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalController, NavParams, NavController } from '@ionic/angular';
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist';
import { IconType, IconPath } from 'src/app/shared/models/floor-plan-icon.model';
import * as dd from 'dingtalk-jsapi'; // 引入钉钉jsapi
declare var Hammer: any;


// Hammer
GlobalWorkerOptions.workerSrc = 'assets/pdfjs/pdf.worker.min.js';

@Component({
  selector: 'floor-plan-dialog',
  templateUrl: './floor-plan-dialog.component.html',
  styleUrls: ['./floor-plan-dialog.component.scss']
})
export class FloorPlanDialogComponent implements OnInit, AfterViewInit {
  mapUrl: string;
  fileType: string;
  pointData: any[] = [];
  markerType: IconType;
  mode: 'view' | 'point' = 'view';
  showStats = false;
  statsData: any;
  multiplePoints = false;
  module: 'floor-plan' | 'heat-map' = 'floor-plan';

  @ViewChild('canvas1') canvasRef: ElementRef;
  @ViewChild('pdfCanvas') pdfCanvasRef: ElementRef;
  @ViewChild('mychart') mychartRef: ElementRef;

  readonly markerSize = 32;
  readonly offset = this.markerSize / 2;

  imageOffset = { x: 0, y: 0 };
  imageScale = 1;
  canvasWidth = 0;
  canvasHeight = 0;
  pointAxis;
  isPdf = false;
  statsItems = [
    { label: 'Check Count (excluding drafts/closed)', value: 0 },
    { label: 'BBS Observation Count', value: 0 },
    { label: 'Contractor Projects', value: 0 },
    { label: 'Contractor Work Items', value: 0 },
    { label: 'Contractor Workers', value: 0 },
    { label: 'Incident Count', value: 0 },
    { label: 'Risk Points', value: 0 },
    { label: 'Risk Assessments', value: 0 },
    { label: 'GMP Audits', value: 0 }
  ];

  // 缩放的变量
  scale = 1;
  isDragging = false;
  lastScale = 1;
  lastPosX = 0;
  lastPosY = 0;
  posX = 0;
  posY = 0;
  originalWidth = 0;
  originalHeight = 0;
  pdfUrl;

  constructor(
  	public modalCtrl: ModalController,
  	public navCtrl: NavController,
		public navParams: NavParams,
		private translateService: TranslateService,
  ) {
  	let params = this.navParams.data;
  	this.mapUrl = params.mapUrl ? params.mapUrl : '';
  	this.fileType = params.fileType ? params.fileType : '';
  	this.pointData = params.pointData ? params.pointData : [];
  	this.markerType = params.markerType ? params.markerType : IconType.LocationPoint;
  	this.mode = params.mode ? params.mode : 'view';
  	this.showStats = params.showStats ? params.showStats : false;
  	this.statsData = params.statsData ? params.statsData : {};
  	this.multiplePoints = params.multiplePoints ? params.multiplePoints : false;

  	this.isPdf = this.fileType && this.fileType.toLowerCase().endsWith('.pdf');
  	
    GlobalWorkerOptions.workerSrc = 'assets/pdfjs/pdf.worker.min.js';
  }

  ngOnInit() {
    // 设置标题
		document.getElementsByTagName('title').item(0).innerText = this.translateService.instant('shared_components.common.view_floor_plan');
		if (dd.env.platform !== 'notInDingTalk') {
			dd.biz.navigation.setTitle({
				title: this.translateService.instant('shared_components.common.view_floor_plan') // 钉钉设置导航栏标题
			});
		}
  }

  async ngAfterViewInit() {
    const overlayCanvas = this.canvasRef ? this.canvasRef.nativeElement : null;
    const pdfCanvas = this.pdfCanvasRef ? this.pdfCanvasRef.nativeElement : null;
    // const canvas = this.isPdf
      // ? (this.pdfCanvasRef ? this.pdfCanvasRef.nativeElement : null)
      // : (this.canvasRef ? this.canvasRef.nativeElement : null);

    // const canvas = document.getElementById('myCanvas');
    // const mc = new Hammer(canvas); // 创建Hammer实例绑定到canvas元素上
    // let this.scale = 1; // 缩放比例初始值
    // let img = new Image(); // 同上，加载图片并设置画布


    const container = document.getElementById('mychart');
    if (!container) return;

    if (this.isPdf) {
      const imgUrl = await this.changePdfToImgUrl();
      // let img = document.getElementById('plane-map-pdf') as HTMLImageElement;
      // img.onload = (e) => {
        const canvasW = 900;
        const canvasH = 600;
        overlayCanvas.width = canvasW;
        overlayCanvas.height = canvasH;
        this.canvasWidth = canvasW;
        this.canvasHeight = canvasH;
      // };

      // await this.renderPdf(pdfCanvas, container);
    } else if (!this.isPdf && overlayCanvas) {
      const img = document.getElementById('plane-map');
      img.onload = (e) => {
        const canvasW = 900;
        const canvasH = 600;
        overlayCanvas.width = canvasW;
        overlayCanvas.height = canvasH;
        this.canvasWidth = canvasW;
        this.canvasHeight = canvasH;
      };
    }

    this.setPointMarkers(container);

    // 初始化手势识别
    // this.initGestures();

    // Important: attach click listener to overlay canvas (used for both modes)
    if (this.mode === 'point' && overlayCanvas) {
      overlayCanvas.addEventListener('click', this.getPoint.bind(this));
    }
  }

  renderPdf(canvas: HTMLCanvasElement, container: HTMLElement): Promise<void> {
    let that = this;
    return new Promise((resolve, reject) => {
      getDocument(this.mapUrl).promise.then(pdf => {
        pdf.getPage(1).then(page => {
          const viewport = page.getViewport({ scale: 1 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          const canvasW = 900;
          const canvasH = 600;

          // Set canvas to fixed size
          canvas.width = canvasW;
          canvas.height = canvasH;

          const scaleX = canvasW / viewport.width;
          const scaleY = canvasH / viewport.height;
          const scale = Math.min(scaleX, scaleY);

          const scaledViewport = page.getViewport({ scale: 1 }); // keep scale 1, we’ll handle scaling manually

          if (!context) return reject('No canvas context');

          // Calculate translation (to center)
          const offsetX = (canvasW - viewport.width * scale) / 2;
          const offsetY = (canvasH - viewport.height * scale) / 2;

          // Clear canvas first
          context.clearRect(0, 0, canvasW, canvasH);

          const renderContext = {
            canvasContext: context,
            viewport: scaledViewport,
            transform: [
              scale, 0,
              0, scale,
              offsetX,
              offsetY
            ]
          };

          page.render(renderContext).promise.then(() => {
              // 将canvas转换为图片URL
              const imageUrl: any = canvas.toDataURL('image/png');
              // const pdfImageDiv: any = document.getElementById('pdfImage');

              // const id = 'plane-map';
              // let pointImg = document.createElement('img');
              // pointImg.src = imageUrl;
              // pointImg.id = id;
              resolve(imageUrl);

              // pdfImageDiv.appendChild(pointImg);
              that.pdfUrl = imageUrl;
              // const pdfImage: any = document.getElementById(id);
              
              // pdfImage.onload = (e) => {
                // const canvasW = 900;
                // const canvasH = 600;
                // const overlay = that.canvasRef ? that.canvasRef.nativeElement : null;
                // if (overlay) {
                //   overlay.width = canvasW;
                //   overlay.height = canvasH;
                // }
                // that.canvasWidth = canvasW;
                // that.canvasHeight = canvasH;
              // };
          });



          // const canvasW = 900;
          // const canvasH = 600;

          // // Set canvas to fixed size
          // canvas.width = canvasW;
          // canvas.height = canvasH;

          // const scaleX = canvasW / viewport.width;
          // const scaleY = canvasH / viewport.height;
          // const scale = Math.min(scaleX, scaleY);

          // const scaledViewport = page.getViewport({ scale: 1 }); // keep scale 1, we’ll handle scaling manually

          // const context = canvas.getContext('2d');
          // if (!context) return reject('No canvas context');

          // // Calculate translation (to center)
          // const offsetX = (canvasW - viewport.width * scale) / 2;
          // const offsetY = (canvasH - viewport.height * scale) / 2;

          // // Clear canvas first
          // context.clearRect(0, 0, canvasW, canvasH);

          // const renderContext = {
          //   canvasContext: context,
          //   viewport: scaledViewport,
          //   transform: [
          //     scale, 0,
          //     0, scale,
          //     offsetX,
          //     offsetY
          //   ]
          // };

          // const renderTask = page.render(renderContext);
          // renderTask.promise.then(() => resolve(), err => reject(err));
          // const overlay = that.canvasRef ? that.canvasRef.nativeElement : null;          
          // if (overlay) {
          //   overlay.width = canvasW;
          //   overlay.height = canvasH;
          // }
          // that.canvasWidth = canvasW;
          // that.canvasHeight = canvasH;
        }, reject);
      }, reject);
    });
  }

  getPoint(event: MouseEvent) {
    const canvas = this.canvasRef ? this.canvasRef.nativeElement : null;
    if (!canvas) return;
    
    const a = document.getElementById('mychart').getBoundingClientRect();
    const imgPinchScaleX = a.width / 900;
    const imgPinchScaleY = a.height / 600;
    this.scale = imgPinchScaleX;
    // console.log(a, imgPinchScaleX, imgPinchScaleY);

    const rect = canvas.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;

    const xPercent = (x / this.canvasWidth) * 100;
    const yPercent = (y / this.canvasHeight) * 100;

    this.pointAxis = {
      xAxis: (xPercent/this.scale).toFixed(2),
      yAxis: (yPercent/this.scale).toFixed(2)
    };

    const container = document.getElementById('mychart');
    // const mychartRef = this.mychartRef ? this.mychartRef.nativeElement : null;

    if (!container) return;

    if (!this.multiplePoints) {
      const existing = container.querySelectorAll('img[id^="point-img"]');
      for (let i = 0; i < existing.length; i++) {
        existing[i].remove();
      }
      this.pointData = [];
    }

    const id = 'point-img' + (this.pointData.length > 0 ? this.pointData[0].id : '0');
    let pointImg = document.createElement('img');
    pointImg.src = IconPath[this.markerType];
    pointImg.id = id;

    const ab = (yPercent/this.scale).toFixed(2);
    const aa = (xPercent/this.scale).toFixed(2)
    const positionText = `top: `+ 'calc(' + (yPercent/this.scale).toFixed(2) + '% - ' + this.offset + 'px);left: '+ 'calc(' + (xPercent/this.scale).toFixed(2) + '% - ' + this.offset + 'px)';
    pointImg.style.cssText = 'width: ' + this.markerSize + 'px; height: ' + this.markerSize + 'px; position: absolute;z-index: 99;'+ positionText;
    container.appendChild(pointImg);
    console.log(pointImg.style.cssText, positionText, aa, ab, '123123123123');
    this.pointData.push({
      xAxis: this.pointAxis.xAxis,
      yAxis: this.pointAxis.yAxis,
      id: id
    });
  }

  setPointMarkers(container: HTMLElement) {
    const data = this.multiplePoints ? this.pointData : (this.pointData && this.pointData.length > 0 ? [this.pointData[0]] : []);
    for (let i = 0; i < data.length; i++) {
      const item = data[i];
      const id = 'point-img' + item.id;
      if (document.getElementById(id)) continue;

      const img = document.createElement('img');
      img.src = IconPath[this.markerType];
      img.id = id;
      img.style.cssText = 'width: ' + this.markerSize + 'px; height: ' + this.markerSize + 'px; position: absolute;z-index: 99;';
      img.style.left = 'calc(' + item.xAxis + '% - ' + this.offset + 'px)';
      img.style.top = 'calc(' + item.yAxis + '% - ' + this.offset + 'px)';
      container.appendChild(img);
    }
  }

  async cancel() {
		await this.modalCtrl.dismiss();
		history.back();
	}

	async confirm() {
		await this.modalCtrl.dismiss(this.pointAxis);
		history.back();
	}

  initGestures() {
    let that = this;
    const canvasWrapper = document.getElementById('canvas');

    const hammer = new Hammer(canvasWrapper);

    // 启用pinch和pan识别
    hammer.get('pinch').set({ enable: true });
    hammer.get('pan').set({ direction: Hammer.DIRECTION_ALL });
    
    // 平移手势
    hammer.on('panstart panmove', function(e) {
        const canvas: any = document.getElementById('canvas');

        if (that.scale <= 1) return;
        
        if (e.type === 'panstart') {
            that.isDragging = true;
            that.lastPosX = that.posX;
            that.lastPosY = that.posY;
        }
        
        that.posX = that.lastPosX + e.deltaX;
        that.posY = that.lastPosY + e.deltaY;
        
        // 限制拖动边界
        const limitX = (that.canvasWidth * that.scale - canvas.width) / 2;
        const limitY = (that.canvasHeight * that.scale - canvas.height) / 2;
        
        that.posX = Math.min(Math.max(that.posX, -limitX), limitX);
        that.posY = Math.min(Math.max(that.posY, -limitY), limitY);
        
        // drawImage();
    });
    
    hammer.on('panend', function() {
        that.isDragging = false;
    });
    
    // 缩放手势
    hammer.on('pinchstart pinchmove', function(e) {
        if (e.type === 'pinchstart') {
          that.lastScale = this.scale;
        }
        const canvas: any = document.getElementById('canvas');

        that.scale = Math.max(0.5, Math.min(that.lastScale * e.this.scale, 5));
        
        // 缩放时调整位置，使缩放中心保持在手指位置
        const scaleChange = that.scale - that.lastScale;
        that.posX -= (e.center.x - canvas.width / 2 - that.posX) * (scaleChange / that.scale);
        that.posY -= (e.center.y - canvas.height / 2 - that.posY) * (scaleChange / that.scale);
        
        // drawImage();
    });
    
    // 双击重置
    hammer.on('doubletap', function() {
        that.resetView();
    });
    
    // 点击添加标记（在标记模式下）
    hammer.on('tap', function(e) {
      // || !isMarkMode
        // if (that.isDragging) return;
        // const canvas: any = document.getElementById('canvas');

        // const rect = canvasWrapper.getBoundingClientRect();
        // const x = e.center.x - rect.left;
        // const y = e.center.y - rect.top;

        // 转换为图片上的相对坐标
        // const imgX = ((x - canvas.width / 2 - that.posX) / that.scale + that.canvasWidth / 2) / that.canvasWidth * 100;
        // const imgY = ((y - canvas.height / 2 - that.posY) / that.scale + that.canvasHeight / 2) / that.canvasHeight * 100;
        
        // that.addMarker(x, y, canvas);
    });

    hammer.on('pinch', function(e) {
      var scale = e.scale; // 获取当前的缩放比例（放大倍数）
      that.scale = scale;
      // console.log('Current scale:', scale);
    })
    
  }

  // 重置视图
  resetView() {
    this.scale = 1;
    this.posX = 0;
    this.posY = 0;
    // this.drawImage();
  }

  // addMarker(x, y, canvas) {
  //   // const rect = canvas.getBoundingClientRect();
  //   // const x = event.clientX - rect.left;
  //   // const y = event.clientY - rect.top;
  //   const xPercent = (x / this.canvasWidth) * 100;
  //   const yPercent = (y / this.canvasHeight) * 100;

  //   this.pointAxis = {
  //     xAxis: (xPercent/this.scale).toFixed(2),
  //     yAxis: (yPercent/this.scale).toFixed(2)
  //   };
  //   alert('TAP:' + JSON.stringify(this.pointAxis))

  //   const container = document.getElementById('mychart');
  //   if (!container) return;

  //   if (!this.multiplePoints) {
  //     const existing = container.querySelectorAll('img[id^="point-img"]');
  //     for (let i = 0; i < existing.length; i++) {
  //       existing[i].remove();
  //     }
  //     this.pointData = [];
  //   }

  //   const id = 'point-img' + (this.pointData.length > 0 ? this.pointData[0].id : '0');
  //   const pointImg = document.createElement('img');
  //   pointImg.src = IconPath[this.markerType];
  //   pointImg.id = id;
  //   pointImg.style.cssText = 'width: ' + this.markerSize + 'px; height: ' + this.markerSize + 'px; position: absolute;z-index: 99;';
  //   pointImg.style.top = 'calc(' + yPercent + '% - ' + this.offset + 'px)';
  //   pointImg.style.left = 'calc(' + xPercent + '% - ' + this.offset + 'px)';

  //   container.appendChild(pointImg);
  //   this.pointData.push({
  //     xAxis: this.pointAxis.xAxis,
  //     yAxis: this.pointAxis.yAxis,
  //     id: id
  //   });
  // }

  changePdfToImgUrl(): Promise<void> {
    let that = this;
    return new Promise((resolve, reject) => {
      getDocument(this.mapUrl).promise.then(pdf => {
        pdf.getPage(1).then(page => {
          const viewport = page.getViewport({ scale: 1 });
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');

          const canvasW = 900;
          const canvasH = 600;

          // Set canvas to fixed size
          canvas.width = canvasW;
          canvas.height = canvasH;

          const scaleX = canvasW / viewport.width;
          const scaleY = canvasH / viewport.height;
          const scale = Math.min(scaleX, scaleY);

          const scaledViewport = page.getViewport({ scale: 1 }); // keep scale 1, we’ll handle scaling manually

          if (!context) return reject('No canvas context');

          // Calculate translation (to center)
          const offsetX = (canvasW - viewport.width * scale) / 2;
          const offsetY = (canvasH - viewport.height * scale) / 2;

          // Clear canvas first
          context.clearRect(0, 0, canvasW, canvasH);

          const renderContext = {
            canvasContext: context,
            viewport: scaledViewport,
            transform: [
              scale, 0,
              0, scale,
              offsetX,
              offsetY
            ]
          };

          page.render(renderContext).promise.then(() => {
              // 将canvas转换为图片URL
              const imageUrl: any = canvas.toDataURL('image/png');
              that.pdfUrl = imageUrl;
              resolve(imageUrl);
              // const pdfImageDiv: any = document.getElementById('pdfImage');

              // const id = 'plane-map';
              // let pointImg = document.createElement('img');
              // pointImg.src = imageUrl;
              // pointImg.id = id;
              // // pointImg.style.cssText = 'width: ' + this.markerSize + 'px; height: ' + this.markerSize + 'px; position: absolute;z-index: 99;';
              // // pointImg.style.top = 'calc(' + (yPercent/this.scale).toFixed(2) + '% - ' + this.offset + 'px)';
              // // pointImg.style.left = 'calc(' + (xPercent/this.scale).toFixed(2) + '% - ' + this.offset + 'px)';    

              // pdfImageDiv.appendChild(pointImg);
              // that.pdfUrl = imageUrl;
              // const pdfImage: any = document.getElementById(id);

              // pdfImage.onload = (e) => {
              //   const canvasW = 900;
              //   const canvasH = 600;
              //   const overlay = that.canvasRef ? that.canvasRef.nativeElement : null;
              //   if (overlay) {
              //     overlay.width = canvasW;
              //     overlay.height = canvasH;
              //   }
              //   this.canvasWidth = canvasW;
              //   this.canvasHeight = canvasH;
              // };
          });

        }, reject);
      }, reject);
    });
  }
}
